export default __webpack_public_path__ + "static/media/videoviews-old.f865ebcc.png";